export interface ResolveDraftAutosaveArgs {
  message: string;
  loadedContent: string | undefined;
  draftId: string | undefined;
  isEditingScheduled: boolean;
}

export type DraftAutosaveAction =
  | { type: "skip" }
  | { type: "create"; message: string }
  | { type: "update"; id: string; message: string }
  | { type: "delete"; id: string };

export const resolveDraftAutosave = ({
  message,
  loadedContent,
  draftId,
  isEditingScheduled,
}: ResolveDraftAutosaveArgs): DraftAutosaveAction => {
  if (isEditingScheduled) return { type: "skip" };

  const trimmed = message.trim();
  if (!trimmed) return draftId ? { type: "delete", id: draftId } : { type: "skip" };
  if (trimmed === (loadedContent ?? "").trim()) return { type: "skip" };

  return draftId ? { type: "update", id: draftId, message } : { type: "create", message };
};
